"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressProvider = exports.AddressContext = void 0;
var _react = require("react");
var _address = _interopRequireDefault(require("./service/address"));
var _reducers = require("./store/reducers");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AddressContext = exports.AddressContext = /*#__PURE__*/(0, _react.createContext)({
  state: _reducers.initialState
});
const AddressProvider = ({
  children,
  env
}) => {
  const init = initial => {
    initial.client = new _address.default(env);
    return initial;
  };
  const [state, dispatch] = (0, _react.useReducer)(_reducers.reducer, _reducers.initialState, init);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AddressContext.Provider, {
    value: {
      state,
      dispatch
    },
    children: children
  });
};
exports.AddressProvider = AddressProvider;